import { render, staticRenderFns } from "./InnerDetail.vue?vue&type=template&id=e188f23c&scoped=true"
import script from "./InnerDetail.vue?vue&type=script&lang=js"
export * from "./InnerDetail.vue?vue&type=script&lang=js"
import style0 from "./InnerDetail.vue?vue&type=style&index=0&id=e188f23c&prod&scoped=true&lang=less"
import style1 from "./InnerDetail.vue?vue&type=style&index=1&id=e188f23c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e188f23c",
  null
  
)

export default component.exports